export class WineryModel {
    Id: number;
    Name: string;
    CountryId: number;
    RegionId: number
    Address1: string;
    Address2: string;
    Suburb: string;
    State: string;
    Postcode: string;
    Phone: string;
    Fax: string;
    Email: string;
    Contact: string;
    CeoFirstname: string;
    CeoLastname: string;
    WinemakerFirstname: string;
    WinemakerLastname: string;

    constructor() {
        this.Name = "";
        this.Address1 = "";
        this.Address2 = "";
        this.Suburb = "";
        this.State = "";
        this.Postcode = "";
        this.Phone = "";
        this.Fax = "";
        this.Email = "";
        this.Contact = "";
        this.CeoFirstname = "";
        this.CeoLastname = "";
        this.WinemakerFirstname = "";
        this.WinemakerLastname = "";
    }
}